import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiTrendingUp, FiTarget, FiActivity, FiX, FiCheck } = FiIcons;

const WhyChoose = () => {
  const benefits = [
    "Visibilitas meningkat di Google & platform digital",
    "Website yang professional dan user-friendly",
    "Strategi lead generation yang teruji & terukur",
    "Pendekatan sistem, bukan trial & error",
    "Fokus ke hasil nyata, bukan jargon marketing"
  ];

  return (
    <section id="solutions" className="py-24 relative overflow-hidden bg-[#0A192F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="space-y-12">
            <div className="space-y-6">
              <h2 className="text-5xl font-black text-white leading-tight">
                Mengapa Bisnis Memilih <br />
                <span className="text-orange-400">GedheMedia?</span>
              </h2>
            </div>
            
            <div className="space-y-4">
              {benefits.map((item, idx) => (
                <div key={idx} className="flex items-center space-x-4 bg-white/5 p-5 rounded-2xl border border-white/10 group hover:border-orange-500/50 transition-all">
                  <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <SafeIcon icon={FiCheck} className="text-white text-lg" />
                  </div>
                  <span className="text-gray-100 font-bold text-lg">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-2xl p-10 rounded-[3rem] border border-white/10 shadow-2xl">
            <h3 className="text-3xl font-black text-white mb-8 text-center">Apa yang Membuat Kami <span className="text-orange-500">Berbeda?</span></h3>
            
            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-red-500/10 border border-red-500/20 p-6 rounded-2xl">
                  <SafeIcon icon={FiX} className="text-red-500 text-2xl mb-3" />
                  <p className="text-gray-400 text-sm font-bold uppercase mb-2">Agensi Biasa</p>
                  <p className="text-white font-bold">Fokus tampilan & follower saja</p>
                </div>
                <div className="bg-green-500/10 border border-green-500/20 p-6 rounded-2xl">
                  <SafeIcon icon={FiCheck} className="text-green-500 text-2xl mb-3" />
                  <p className="text-orange-400 text-sm font-bold uppercase mb-2">GedheMedia</p>
                  <p className="text-white font-bold">Fokus sistem & pertumbuhan</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-red-500/10 border border-red-500/20 p-6 rounded-2xl">
                  <SafeIcon icon={FiX} className="text-red-500 text-2xl mb-3" />
                  <p className="text-white font-bold">Kerja tanpa data yang jelas</p>
                </div>
                <div className="bg-green-500/10 border border-green-500/20 p-6 rounded-2xl">
                  <SafeIcon icon={FiCheck} className="text-green-500 text-2xl mb-3" />
                  <p className="text-white font-bold">Strategi berbasis tujuan & metrik</p>
                </div>
              </div>

              <div className="bg-orange-500/10 border border-orange-500/30 p-8 rounded-2xl text-center">
                <h4 className="text-orange-400 font-black text-xl mb-2">Partner Jangka Panjang</h4>
                <p className="text-white font-medium">Bukan sekadar project sekali jadi (one-time), tapi partner untuk growth berkelanjutan.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;